module.exports = __webpack_public_path__ + "static/media/logo-azul-texto.f991c7f0.svg";